export type BookingStatus = "APPROVED" | "REJECTED" | "CANCELED_BY_BRIDE" | "PENDING";

export function getBookingStatuses(): BookingStatus[] {
  return ['APPROVED', 'REJECTED', 'CANCELED_BY_BRIDE', 'PENDING'];
}

export function bookingStatusToTranslationKey(status: string | undefined): string {
  switch (status) {
    case 'APPROVED':
      return "booking.feedback.booking_status.confirmed";
    case 'REJECTED':
      return "booking.feedback.booking_status.rejected";
    case 'CANCELED_BY_BRIDE':
      return "booking.feedback.booking_status.canceled";
    case 'PENDING':
      return "booking.feedback.booking_status.pending";
    default:
      return "global.unknown";
  }
} 